import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tabs-wrap" }
const _hoisted_2 = ["onClick", "onMouseenter"]

import { Tab } from '@/types/tabs';
import SingleTab from '@/components/widgets/SingleTab';
import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    items: {},
    dropdownForTab: {}
  },
  emits: ['click', 'mouseenter'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const dropdownTabClickCount = ref(0);

const emit = __emit;

const isTabSelected = (tabId: string) => {
  return props.items.find((t) => t.id === tabId)?.selected;
};

const clickHandler = (tabId: string) => {
  dropdownTabClickCount.value =
    tabId === props.dropdownForTab ? dropdownTabClickCount.value + 1 : 0;

  if (isTabSelected(tabId)) return;
  emit('click', tabId);
};

const mouseEnterHandler = (tabId: string) => {
  emit('mouseenter', tabId);
};

const handleClickDropdownItem = () => (dropdownTabClickCount.value = 1);

onMounted(() => {
  /**
   * If the dropdown tab is already selected, set click count to 1,
   * otherwise clear it out
   */
  const selectedTab = (props?.items || []).find((t) => t.selected);
  dropdownTabClickCount.value = Number(selectedTab?.id === props.dropdownForTab);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        key: tab.id,
        onClick: ($event: any) => (clickHandler(tab.id)),
        onMouseenter: ($event: any) => (mouseEnterHandler(tab.id))
      }, [
        _createVNode(_unref(SingleTab), {
          tab: tab,
          "dropdown-for-tab": _ctx.dropdownForTab,
          "tab-click-count": dropdownTabClickCount.value,
          onClickDropdownItem: handleClickDropdownItem
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 2
        }, 1032, ["tab", "dropdown-for-tab", "tab-click-count"])
      ], 40, _hoisted_2))
    }), 128))
  ]))
}
}

})